import { isSessionGone, type ApiResponse } from '@/lib/api-contract';

/**
 * What the page-load session check (use-auth) does with its answer:
 * - 'apply': install the user and token it returned.
 * - 'signed-out': the session is gone.
 * - 'unreachable': no answer, or a server error; keep this tab's stored user.
 * - 'superseded': this tab signed in, signed out or got a new token while the check was out, so
 *   its answer is about a session the tab has already left. A late 401 must not sign out someone
 *   who has just signed in.
 */
export type SessionBootstrapStep = 'apply' | 'signed-out' | 'unreachable' | 'superseded';

export function sessionBootstrapStep(
  res: ApiResponse<unknown>,
  tokenAtStart: string | null,
  tokenNow: string | null
): SessionBootstrapStep {
  if (tokenNow !== tokenAtStart) return 'superseded';
  if (res.data) return 'apply';
  if (isSessionGone(res.status)) return 'signed-out';
  return 'unreachable';
}
